// extracted by mini-css-extract-plugin
module.exports = {"title":"addNote_title__2GFGb","input":"addNote_input__Z86Xs","container":"addNote_container__3y9uT"};